export default __webpack_public_path__ + "static/media/mobile_native_dev_img.36f1349a.svg";